// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YoutubeOutlinedSvg from "@fishx/icons-svg/es/asn/YoutubeOutlined";
import FishxIcon from '../components/FishxIcon';

var YoutubeOutlined = function YoutubeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeOutlinedSvg
  }));
};

YoutubeOutlined.displayName = 'YoutubeOutlined';
export default React.forwardRef(YoutubeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/YoutubeOutlined.js
// module id = 4417
// module chunks = 0